<app-header [menuList$]="menuList$" [memberInfo$]="memberInfo$"></app-header>

<app-sub-header [currMenu]="currMenu$" [memberInfo]="memberInfo$"></app-sub-header>

<form [formGroup]="form">

  <div id="customercenter-magazine-subscription">
    <div class="inner-wrap">

      <ul class="magazine-tab">
        <li class="nav-item"><a routerLink="/customerCenter/magazine" class="nav-link">협회지</a></li>
        <li class="nav-item"><a routerLink="/customerCenter/magazine/subscription" class="nav-link active">정기구독안내</a></li>
      </ul>

      <div class="tab-content">
        <div class="page-title">정기구독안내</div>

        <div class="info">*필수입력입니다.</div>

        <table>
        <colgroup>
          <col class="col1">
          <col class="col2">
        </colgroup>

        <tbody>
        <tr>
          <th><span class="necessary" >*</span> 회사명(신청인)</th>
          <td>
            <input type="text" id="company" formControlName="company" [ngClass]="{formErrors:formErrors['company']}" />
            <span *ngIf="formErrors['company']" class="cred ml5">{{formErrors['company']}}</span>
          </td>
        </tr>
        <tr>
          <th><span class="necessary" >*</span> 입금자</th>
          <td>
            <input type="text" id="name" formControlName="name" [ngClass]="{formErrors:formErrors['name']}" />
            <span *ngIf="formErrors['name']" class="cred ml5">{{formErrors['name']}}</span>
          </td>
        </tr>
        <tr>
          <th><span class="necessary" >*</span> 부서</th>
          <td>
            <input type="text" id="dept" formControlName="dept" [ngClass]="{formErrors:formErrors['dept']}" />
            <span *ngIf="formErrors['dept']" class="cred ml5">{{formErrors['dept']}}</span>
          </td>
        </tr>
        <tr>
          <th><span class="necessary" >*</span> 담당자</th>
          <td>
            <input type="text" id="chargePerson" formControlName="chargePerson" [ngClass]="{formErrors:formErrors['chargePerson']}" />
            <span *ngIf="formErrors['chargePerson']" class="cred ml5">{{formErrors['chargePerson']}}</span>
          </td>
        </tr>
        <tr>
          <th><span class="necessary" >*</span> 구독기간</th>
          <td class="term">
            <input type="hidden" id="subscriptionType" formControlName="subscriptionType" />
            <div class="form-inline">
              <div class="btn-group mr10">
                <button *ngFor="let item of associationStatusList" type="button" class="btn btn-default btn-small" [ngClass]="{active: form.controls.subscriptionType.value==item.common_code}" (click)="form.get('subscriptionType').setValue(item.common_code)">{{item.common_name}}</button>
              </div>
              <ng-container *ngIf="form.controls.subscriptionType.value=='1000'">
                <input type="text" id="ho1" formControlName="ho1" class="cnt" />
                <span class="pr5 pl5">호 /</span>
                <input type="text" id="date1" formControlName="date1" class="calendar-input" readonly="true" (click)="setMonthPicker1()" />
                부터 ~
                <input type="text" id="ho2" formControlName="ho2" class="cnt" />
                호 /
                <input type="text" id="date2" formControlName="date2" class="calendar-input" readonly="true" (click)="setMonthPicker2()" />
                까지
                <span class="space"></span>
                (각호
                <input type="text" id="bu1" formControlName="bu1" class="cnt" />
                부)
              </ng-container>

              <ng-container *ngIf="form.controls.subscriptionType.value=='2000'">
                <input type="text" id="ho3" formControlName="ho3" class="cnt" />
                호 /
                <input type="text" id="date3" formControlName="date3" class="calendar-input" readonly="true" (click)="setMonthPicker3()" />
                ~ 계속
                <span class="space"></span>
                (각호
                <input type="text" id="bu2" formControlName="bu2" class="cnt" />
                부)
              </ng-container>
              <span *ngIf="formErrors['subscriptionType']" class="cred ml5">{{formErrors['subscriptionType']}}</span>
            </div>
          </td>
        </tr>
        <tr>
          <th><span class="necessary" >*</span> 주소</th>
          <td>
            <div class="zipcode">
              <input type="text" id="zipcode" formControlName="zipcode" readonly="true" />
              <btn-daum-address (result)="setDaumAddressApi($event)" [options]="daumAddressOptions"></btn-daum-address>
              <span *ngIf="formErrors['zipcode']" class="cred ml5">{{formErrors['zipcode']}}</span>
            </div>
            <input type="text" class="addr1" id="address" formControlName="address" readonly="true" />
            <input type="text" class="addr2" id="addressDetail" formControlName="addressDetail" placeholder="나머지 주소를 입력해 주세요."/>
          </td>
        </tr>
        <tr>
          <th><span class="necessary" >*</span> 연락처</th>
          <td class="tel">
            <input type="text" id="tel1" formControlName="tel1" />
            <span class="between">-</span>
            <input type="text" id="tel2" formControlName="tel2" />
            <span class="between">-</span>
            <input type="text" id="tel3" formControlName="tel3" />
            <span *ngIf="formErrors['tel1'] || formErrors['tel2'] || formErrors['tel3']" class="cred ml5">{{ formErrors['tel1'] ? formErrors['tel1'] : ( formErrors['tel2'] ? formErrors['tel2'] : ( formErrors['tel3'] ? formErrors['tel3'] : '' ) ) }}</span>
          </td>
        </tr>
        <tr>
          <th>기타</th>
          <td><textarea id="content" formControlName="content" class="etc"></textarea></td>
        </tr>
        <tr class="h50">
          <th>구독료</th>
          <td>1년(12회) \ 48,000원</td>
        </tr>
        <tr>
          <th>구독료 납부방법</th>
          <td>
                청구 지로는 발행하지 않으니, 온라인신청과 동시에 아래의 계좌로 입금해 주시기 바랍니다.
            <p class="bank-info">
              <span>
                - 농협중앙회(083-17-000856)<br/>
                - 예금주 : 한국냉동공조산업협회<br/>
              </span>
              - 발신인 : 신청자 성명 또는 업체명 명기 요망
            </p>
          </td>
        </tr>
        <tr class="h50">
          <th>문의처</th>
          <td>한국냉동공조산업협회 업무부 Tel : (02) 2193-4323 / Fax : (02) 785-1195) 회지 담당자</td>
        </tr>
        </tbody>
        </table>

        <div class="btn-area">
          <div class="txt">위와 같이 "냉난방공조"지의 정기구독을 신청합니다.</div>
          <div class="com">한국냉동공조산업협회</div>
          <button class="apply-btn" (click)="setAssociationSubscriptionSave()">신청하기</button>
        </div>
      </div>

    </div>
  </div>

</form>

<app-footer></app-footer>